/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AbpPtwExceptionHttpResponseModel,
  AddMedicalSystemOptionsDto,
  BeamQualityDto,
  CreateMedicalSystemRtSystemDto,
  HistoryDto,
  ManufacturerModelsDto,
  MedicalSystemCatalogDto,
  MedicalSystemOptionsCatalogDto,
  MedicalSystemRtSystemDto,
  ODataPostProcessedResultsOfMedicalSystemRtSystemDto,
  ProblemDetails,
  ValidateBeamQualityDto,
} from '../models/index';
import {
    AbpPtwExceptionHttpResponseModelFromJSON,
    AbpPtwExceptionHttpResponseModelToJSON,
    AddMedicalSystemOptionsDtoFromJSON,
    AddMedicalSystemOptionsDtoToJSON,
    BeamQualityDtoFromJSON,
    BeamQualityDtoToJSON,
    CreateMedicalSystemRtSystemDtoFromJSON,
    CreateMedicalSystemRtSystemDtoToJSON,
    HistoryDtoFromJSON,
    HistoryDtoToJSON,
    ManufacturerModelsDtoFromJSON,
    ManufacturerModelsDtoToJSON,
    MedicalSystemCatalogDtoFromJSON,
    MedicalSystemCatalogDtoToJSON,
    MedicalSystemOptionsCatalogDtoFromJSON,
    MedicalSystemOptionsCatalogDtoToJSON,
    MedicalSystemRtSystemDtoFromJSON,
    MedicalSystemRtSystemDtoToJSON,
    ODataPostProcessedResultsOfMedicalSystemRtSystemDtoFromJSON,
    ODataPostProcessedResultsOfMedicalSystemRtSystemDtoToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
    ValidateBeamQualityDtoFromJSON,
    ValidateBeamQualityDtoToJSON,
} from '../models/index';

export interface CreateMedicalSystemRtSystemRequest {
    createMedicalSystemRtSystemDto?: CreateMedicalSystemRtSystemDto;
}

export interface DeleteMedicalSystemRtSystemRequest {
    id: string;
}

export interface GetAllManufacturersRequest {
    category?: string;
}

export interface GetAllMedicalSystemOptionsCatalogRequest {
    category?: string;
}

export interface GetBeamQualityTemplateRequest {
    radiationType: GetBeamQualityTemplateRadiationTypeEnum;
}

export interface GetManufacturersModelsCatalogRequest {
    category?: string;
    subCategory?: string;
}

export interface GetMedicalSystemHistoryRequest {
    id: string;
}

export interface GetMedicalSystemRtSystemRequest {
    id: string;
}

export interface GetMedicalSystemRtSystemListRequest {
    $filter?: string;
    $search?: string;
    $top?: number;
    $skip?: number;
    $orderby?: string;
}

export interface GetMedicalSystemTemplateRequest {
    category?: string;
    subCategory?: string;
    manufacturer?: string;
    model?: string;
    subModel?: string;
    beamLimitingDeviceType?: string;
    beamProduction?: string;
}

export interface GetNewRTSystemOptionsRequest {
    category?: string;
    subCategory?: string;
    manufacturer?: string;
    model?: string;
    subModel?: string;
    beamLimitingDeviceType?: string;
}

export interface GetNewRTSystemOptionsFullNameRequest {
    category?: string;
}

export interface UpdateMedicalSystemRtSystemRequest {
    id: string;
    createMedicalSystemRtSystemDto?: CreateMedicalSystemRtSystemDto;
}

export interface ValidateBeamQualityRequest {
    validateBeamQualityDto?: ValidateBeamQualityDto;
}

export interface ValidateMedicalSystemRtSystemRequest {
    createMedicalSystemRtSystemDto?: CreateMedicalSystemRtSystemDto;
}

/**
 * 
 */
export class MedicalSystemsApi extends runtime.BaseAPI {

    /**
     * Adds a new entity
     */
    async createMedicalSystemRtSystemRaw(requestParameters: CreateMedicalSystemRtSystemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MedicalSystemRtSystemDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/medical-systems`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateMedicalSystemRtSystemDtoToJSON(requestParameters.createMedicalSystemRtSystemDto),
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => MedicalSystemRtSystemDtoFromJSON(jsonValue));
    }

    /**
     * Adds a new entity
     */
    async createMedicalSystemRtSystem(requestParameters: CreateMedicalSystemRtSystemRequest = {}, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.createMedicalSystemRtSystemRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<MedicalSystemRtSystemDto>(response, errorHandlers);
    }

    /**
     * Deletes the entity with the given id.
     */
    async deleteMedicalSystemRtSystemRaw(requestParameters: DeleteMedicalSystemRtSystemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteMedicalSystemRtSystem.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/medical-systems/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes the entity with the given id.
     */
    async deleteMedicalSystemRtSystem(requestParameters: DeleteMedicalSystemRtSystemRequest, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.deleteMedicalSystemRtSystemRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<void>(response, errorHandlers);
    }

    /**
     * Get a list of All manufacture
     */
    async getAllManufacturersRaw(requestParameters: GetAllManufacturersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        const queryParameters: any = {};

        if (requestParameters.category !== undefined) {
            queryParameters['category'] = requestParameters.category;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/medical-systems/all-manufacturers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get a list of All manufacture
     */
    async getAllManufacturers(requestParameters: GetAllManufacturersRequest = {}, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getAllManufacturersRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<Array<string>>(response, errorHandlers);
    }

    /**
     */
    async getAllMedicalSystemOptionsCatalogRaw(requestParameters: GetAllMedicalSystemOptionsCatalogRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<MedicalSystemOptionsCatalogDto>>> {
        const queryParameters: any = {};

        if (requestParameters.category !== undefined) {
            queryParameters['category'] = requestParameters.category;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/medical-systems/all-options-full-name`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MedicalSystemOptionsCatalogDtoFromJSON));
    }

    /**
     */
    async getAllMedicalSystemOptionsCatalog(requestParameters: GetAllMedicalSystemOptionsCatalogRequest = {}, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getAllMedicalSystemOptionsCatalogRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<Array<MedicalSystemOptionsCatalogDto>>(response, errorHandlers);
    }

    /**
     */
    async getAllMedicalSystemsCatalogRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<MedicalSystemCatalogDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/medical-systems/catalog`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MedicalSystemCatalogDtoFromJSON));
    }

    /**
     */
    async getAllMedicalSystemsCatalog(errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getAllMedicalSystemsCatalogRaw(initOverrides);
        return this.configuration.handleFunction<Array<MedicalSystemCatalogDto>>(response, errorHandlers);
    }

    /**
     */
    async getBeamQualityTemplateRaw(requestParameters: GetBeamQualityTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BeamQualityDto>> {
        if (requestParameters.radiationType === null || requestParameters.radiationType === undefined) {
            throw new runtime.RequiredError('radiationType','Required parameter requestParameters.radiationType was null or undefined when calling getBeamQualityTemplate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/medical-systems/template-beam-quality/{radiationType}`.replace(`{${"radiationType"}}`, encodeURIComponent(String(requestParameters.radiationType))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => BeamQualityDtoFromJSON(jsonValue));
    }

    /**
     */
    async getBeamQualityTemplate(requestParameters: GetBeamQualityTemplateRequest, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getBeamQualityTemplateRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<BeamQualityDto>(response, errorHandlers);
    }

    /**
     * Get a list of all manufacturers including a list of all its models by Category and SubCategory
     */
    async getManufacturersModelsCatalogRaw(requestParameters: GetManufacturersModelsCatalogRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ManufacturerModelsDto>>> {
        const queryParameters: any = {};

        if (requestParameters.category !== undefined) {
            queryParameters['category'] = requestParameters.category;
        }

        if (requestParameters.subCategory !== undefined) {
            queryParameters['subCategory'] = requestParameters.subCategory;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/medical-systems/manufacturers-models-catalog`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ManufacturerModelsDtoFromJSON));
    }

    /**
     * Get a list of all manufacturers including a list of all its models by Category and SubCategory
     */
    async getManufacturersModelsCatalog(requestParameters: GetManufacturersModelsCatalogRequest = {}, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getManufacturersModelsCatalogRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<Array<ManufacturerModelsDto>>(response, errorHandlers);
    }

    /**
     */
    async getMedicalSystemHistoryRaw(requestParameters: GetMedicalSystemHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<HistoryDto>>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getMedicalSystemHistory.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/medical-systems/{id}/history`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(HistoryDtoFromJSON));
    }

    /**
     */
    async getMedicalSystemHistory(requestParameters: GetMedicalSystemHistoryRequest, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getMedicalSystemHistoryRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<Array<HistoryDto>>(response, errorHandlers);
    }

    /**
     * Returns one entity for detail view.
     */
    async getMedicalSystemRtSystemRaw(requestParameters: GetMedicalSystemRtSystemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MedicalSystemRtSystemDto>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getMedicalSystemRtSystem.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/medical-systems/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => MedicalSystemRtSystemDtoFromJSON(jsonValue));
    }

    /**
     * Returns one entity for detail view.
     */
    async getMedicalSystemRtSystem(requestParameters: GetMedicalSystemRtSystemRequest, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getMedicalSystemRtSystemRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<MedicalSystemRtSystemDto>(response, errorHandlers);
    }

    /**
     * Returns a list of entities for grid view.
     */
    async getMedicalSystemRtSystemListRaw(requestParameters: GetMedicalSystemRtSystemListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ODataPostProcessedResultsOfMedicalSystemRtSystemDto>> {
        const queryParameters: any = {};

        if (requestParameters.$filter !== undefined) {
            queryParameters['$filter'] = requestParameters.$filter;
        }

        if (requestParameters.$search !== undefined) {
            queryParameters['$search'] = requestParameters.$search;
        }

        if (requestParameters.$top !== undefined) {
            queryParameters['$top'] = requestParameters.$top;
        }

        if (requestParameters.$skip !== undefined) {
            queryParameters['$skip'] = requestParameters.$skip;
        }

        if (requestParameters.$orderby !== undefined) {
            queryParameters['$orderby'] = requestParameters.$orderby;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/medical-systems`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => ODataPostProcessedResultsOfMedicalSystemRtSystemDtoFromJSON(jsonValue));
    }

    /**
     * Returns a list of entities for grid view.
     */
    async getMedicalSystemRtSystemList(requestParameters: GetMedicalSystemRtSystemListRequest = {}, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getMedicalSystemRtSystemListRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<ODataPostProcessedResultsOfMedicalSystemRtSystemDto>(response, errorHandlers);
    }

    /**
     */
    async getMedicalSystemTemplateRaw(requestParameters: GetMedicalSystemTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MedicalSystemRtSystemDto>> {
        const queryParameters: any = {};

        if (requestParameters.category !== undefined) {
            queryParameters['category'] = requestParameters.category;
        }

        if (requestParameters.subCategory !== undefined) {
            queryParameters['subCategory'] = requestParameters.subCategory;
        }

        if (requestParameters.manufacturer !== undefined) {
            queryParameters['manufacturer'] = requestParameters.manufacturer;
        }

        if (requestParameters.model !== undefined) {
            queryParameters['model'] = requestParameters.model;
        }

        if (requestParameters.subModel !== undefined) {
            queryParameters['subModel'] = requestParameters.subModel;
        }

        if (requestParameters.beamLimitingDeviceType !== undefined) {
            queryParameters['beamLimitingDeviceType'] = requestParameters.beamLimitingDeviceType;
        }

        if (requestParameters.beamProduction !== undefined) {
            queryParameters['beamProduction'] = requestParameters.beamProduction;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/medical-systems/template`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => MedicalSystemRtSystemDtoFromJSON(jsonValue));
    }

    /**
     */
    async getMedicalSystemTemplate(requestParameters: GetMedicalSystemTemplateRequest = {}, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getMedicalSystemTemplateRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<MedicalSystemRtSystemDto>(response, errorHandlers);
    }

    /**
     */
    async getNewRTSystemOptionsRaw(requestParameters: GetNewRTSystemOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AddMedicalSystemOptionsDto>> {
        const queryParameters: any = {};

        if (requestParameters.category !== undefined) {
            queryParameters['category'] = requestParameters.category;
        }

        if (requestParameters.subCategory !== undefined) {
            queryParameters['subCategory'] = requestParameters.subCategory;
        }

        if (requestParameters.manufacturer !== undefined) {
            queryParameters['manufacturer'] = requestParameters.manufacturer;
        }

        if (requestParameters.model !== undefined) {
            queryParameters['model'] = requestParameters.model;
        }

        if (requestParameters.subModel !== undefined) {
            queryParameters['subModel'] = requestParameters.subModel;
        }

        if (requestParameters.beamLimitingDeviceType !== undefined) {
            queryParameters['beamLimitingDeviceType'] = requestParameters.beamLimitingDeviceType;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/medical-systems/options`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => AddMedicalSystemOptionsDtoFromJSON(jsonValue));
    }

    /**
     */
    async getNewRTSystemOptions(requestParameters: GetNewRTSystemOptionsRequest = {}, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getNewRTSystemOptionsRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<AddMedicalSystemOptionsDto>(response, errorHandlers);
    }

    /**
     */
    async getNewRTSystemOptionsFullNameRaw(requestParameters: GetNewRTSystemOptionsFullNameRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AddMedicalSystemOptionsDto>> {
        const queryParameters: any = {};

        if (requestParameters.category !== undefined) {
            queryParameters['category'] = requestParameters.category;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/medical-systems/options-full-name`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => AddMedicalSystemOptionsDtoFromJSON(jsonValue));
    }

    /**
     */
    async getNewRTSystemOptionsFullName(requestParameters: GetNewRTSystemOptionsFullNameRequest = {}, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getNewRTSystemOptionsFullNameRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<AddMedicalSystemOptionsDto>(response, errorHandlers);
    }

    /**
     * Updates an entity, if existing
     */
    async updateMedicalSystemRtSystemRaw(requestParameters: UpdateMedicalSystemRtSystemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MedicalSystemRtSystemDto>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateMedicalSystemRtSystem.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/medical-systems/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateMedicalSystemRtSystemDtoToJSON(requestParameters.createMedicalSystemRtSystemDto),
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => MedicalSystemRtSystemDtoFromJSON(jsonValue));
    }

    /**
     * Updates an entity, if existing
     */
    async updateMedicalSystemRtSystem(requestParameters: UpdateMedicalSystemRtSystemRequest, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.updateMedicalSystemRtSystemRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<MedicalSystemRtSystemDto>(response, errorHandlers);
    }

    /**
     */
    async validateBeamQualityRaw(requestParameters: ValidateBeamQualityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/medical-systems/validate-beam-quality`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ValidateBeamQualityDtoToJSON(requestParameters.validateBeamQualityDto),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async validateBeamQuality(requestParameters: ValidateBeamQualityRequest = {}, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.validateBeamQualityRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<void>(response, errorHandlers);
    }

    /**
     * Validates an entity without adding or updating it.
     */
    async validateMedicalSystemRtSystemRaw(requestParameters: ValidateMedicalSystemRtSystemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/medical-systems/validate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateMedicalSystemRtSystemDtoToJSON(requestParameters.createMedicalSystemRtSystemDto),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }

    /**
     * Validates an entity without adding or updating it.
     */
    async validateMedicalSystemRtSystem(requestParameters: ValidateMedicalSystemRtSystemRequest = {}, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.validateMedicalSystemRtSystemRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<void>(response, errorHandlers);
    }

}

/**
 * @export
 */
export const GetBeamQualityTemplateRadiationTypeEnum = {
    Photon: 'Photon',
    Electron: 'Electron',
    Neutron: 'Neutron',
    Proton: 'Proton'
} as const;
export type GetBeamQualityTemplateRadiationTypeEnum = typeof GetBeamQualityTemplateRadiationTypeEnum[keyof typeof GetBeamQualityTemplateRadiationTypeEnum];
